<div class="app-container">
  <router-outlet></router-outlet>
</div>
